import {
    type TCollectionItemsPaginated as TApiCollectionItemsPaginated,
    getCollectionAudiosUrl,
    withQuery,
} from '@core/api'
import { httpClient } from '@core/http-client'
import { webLogger } from '@muse-web/logger'

export const getCollectionAudios = async ({
    username,
    slug,
    page,
}: {
    username: string
    slug: string
    page: number
}) => {
    try {
        return await httpClient
            .get(withQuery(getCollectionAudiosUrl(username, slug), { page }))
            .json<TApiCollectionItemsPaginated>()
    } catch (error) {
        webLogger.error(`Failed to get collection audios: ${String(error)}`)
        throw error
    }
}
